import baseUrl from '../utils/baseUrl'
import axios from './api'

const getAll = async () => await axios.get(baseUrl + `/recommend-a-mechanic/all`).then((response) => response.data)

export { getAll }
